<template>
  <v-card flat>
    <!-- Datatable Filter -->
    <v-card-title>
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field append-icon="filter_list" :label="messages.label.KEYS_FILTER" single-line hide-details clearable
            v-model="search" @input="value => filterKeysList()"></v-text-field>
        </v-flex>
        <v-flex sm1></v-flex>
        <v-flex sm4>
          <v-autocomplete :value="selectedGroup" :label="messages.label.GROUP_NAME" item-text="title" item-value="title"
            :items="groupsList" :loading="loadingGroups" :disabled="loadingGroups" return-object
            @change="updateKeysList">
            <template v-slot:no-data>
              <v-list-tile>
                <v-list-tile-title>No Groups</v-list-tile-title>
              </v-list-tile>
            </template>
          </v-autocomplete>
        </v-flex>
        <!-- <v-flex sm1>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="updateKeysList()" v-on="on" color="secondary" flat :disabled="loadingGroups">
                <v-icon medium>refresh</v-icon>
              </v-btn>
            </template>
            <span>Reload Configurations</span>
          </v-tooltip>
        </v-flex> -->
      </v-layout>
    </v-card-title>
    <!-- Data Table -->
    <v-card-text>
      <v-data-table :headers="headers" :items="filteredKeysList" :loading="keysListLoading"
        :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr @click="showSelectedKeyDetails(props.item)" :active="!!selectedKey && selectedKey.id == props.item.id"
            class="pointer">
            <td class="text-xs-left">{{ props.item.key }}</td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">{{ messages.info.NO_KEY_VALUE_PAIRS }}
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">{{ messages.info.NO_FILTER_KEY_VALUE_PAIRS
          }}</v-alert>
        </template>
        <!-- Page Text -->
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import messages from "@/ConfigService/messages.json"
import { GET_GROUPS, GET_KEY_DETAILS } from "@/store/constants/action-types"
import * as configServiceDataService from "@/ConfigService/ConfigServiceDataService"
import {
  SET_SELECTED_KEY,
  SET_IS_EDIT_MODE,
  SET_CONFIG_DETAILS_SIDE_SHEET,
  SET_SELECTED_GROUP,
  SET_KEY_VALUE_DETAILS,
  SET_CONFIG_ERROR,
  SET_LOADING_GROUPS,
  SET_KEYS_LIST
} from "@/store/constants/mutation-types"

/**
 * initialData
 */
function initialData(instance) {
  return {
    search: "",
    keysListLoading: false,
    totalItems: 0,
    rowsPerPagesArray: [10, 25],
    headers: instance.getTableHeaders(),
    filteredKeysList: []
  }
}

export default {
  name: "ConfigList",
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState("configService", ["groupsList", "selectedKey", "selectedGroup", "loadingGroups", "keysList"])
  },
  watch: {
    selectedGroup: {
      handler(newVal, oldVal) {
        if ( (newVal !== "") && (newVal !== oldVal)) {
          this.retrieveKeysList()
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapMutations("configService", [
      SET_SELECTED_KEY,
      SET_IS_EDIT_MODE,
      SET_CONFIG_DETAILS_SIDE_SHEET,
      SET_SELECTED_GROUP,
      SET_KEY_VALUE_DETAILS,
      SET_CONFIG_ERROR,
      SET_LOADING_GROUPS,
      SET_KEYS_LIST
    ]),
    ...mapActions("configService", [
      GET_GROUPS,
      GET_KEY_DETAILS
    ]),

    /**
     * reset
     */
    reset() { },

    /**
     * getTableHeaders - Construct array of objects to show table headers
     *
     * @return {array}
     */
    getTableHeaders() {
      let headers = [
        {
          text: messages.label.TH_CONFIG_KEY,
          align: "left",
          value: "key",
          sortable: false
        }
      ]
      return headers
    },

    /**
     * Updates the list of key value pairs in the data table
     */
    updateKeysList(value) {
      if (value) {
        this.SET_SELECTED_GROUP(value)
      }
      this.SET_SELECTED_KEY({})
      this.SET_IS_EDIT_MODE(false)
      this.SET_CONFIG_DETAILS_SIDE_SHEET(false)
      //this.retrieveKeysList()
    },

    /**
     * retrieveKeysList - Retrieve keys list
     * @return {Promise}  promise
     */
    retrieveKeysList() {
      // TODO: Update to retrieve all on initial load
      this.keysListLoading = true
      this.SET_KEYS_LIST([])
      configServiceDataService
        .retrieveKeysList(this.selectedGroup)
        .then(response => {
          if (response.data && !this.$lodash.isUndefined(response.data.entries)) {
            let keysArray = response.data.entries
            let keysObjectsArray = []
            this.$lodash.forEach(keysArray, (value, index) => {
              keysObjectsArray.push({ id: index, key: value })
            })
            keysObjectsArray = this.$lodash.sortBy(keysObjectsArray, [function (keyObj) { return keyObj.key.toLowerCase() }])
            this.SET_KEYS_LIST(keysObjectsArray)
            this.filterKeysList()
            this.totalItems = this.keysList.length
          } else {
            this.SET_KEYS_LIST([])
            this.filteredKeysList = []
          }
          this.keysListLoading = false
          return this.keysList
        })
        .catch(error => {
          this.SET_KEYS_LIST([])
          this.filteredKeysList = []
          this.totalItems = 0
          this.keysListLoading = false
          return Promise.reject(error)
        })
    },

    /**
     * Fiter the keys list based on search string
     */
    filterKeysList() {
      if (this.search) {
        this.search = this.search.toString().toLowerCase()
        const displayedKeys = ["key"]
        this.filteredKeysList = this.keysList.filter(obj => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(key => {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(this.search)
            }
          })
        })
      } else {
        this.filteredKeysList = this.keysList
      }
    },

    /**
     * Show key value pair details
     * @param {object} keyObj
     */
    showSelectedKeyDetails(keyObj) {
      this.SET_SELECTED_KEY(keyObj)
      this.SET_IS_EDIT_MODE(true)
      this.SET_CONFIG_DETAILS_SIDE_SHEET(true)
      this.SET_KEY_VALUE_DETAILS({})
      this.GET_KEY_DETAILS({
        groupName: this.selectedGroup.trim(),
        key: keyObj.key.trim()
      }).then((/* response */) => {
        this.SET_CONFIG_ERROR(
          {
            status: "",
            message: ""
          }
        )
      }).catch((error) => {
        if (error.response.status === 404) {
          this.SET_CONFIG_ERROR(
            {
              status: "404",
              message: `Could not retrieve details for key : ${keyObj.key}`
            }
          )
        }
      })
    }

  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initial load
     */
    this.SET_LOADING_GROUPS(true)
    this.GET_GROUPS().then((/* response */) => {
      this.SET_LOADING_GROUPS(false)
      if (this.groupsList.length > 0) {
        this.SET_SELECTED_GROUP(this.groupsList[0])
      }
    })
  },
  beforeDestroy() { }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/ConfigService/ConfigList.vue